import { RefObject, useCallback, useEffect } from "react";

export function useOuterClick<T extends HTMLElement = HTMLElement>(
  refs: RefObject<T>[],
  handler: () => void,
  options?: { ids?: string[]; disabled?: boolean }
) {
  const memoizedHandler = useCallback(handler, [handler]);

  useEffect(() => {
    if (options?.disabled) return;

    const handleOuterClick: EventListener = (event: Event) => {
      const idsElements =
        options?.ids?.map((id) => document.getElementById(id)) || [];
      if (
        refs.some((ref) => ref.current?.contains(event.target as Node)) ||
        idsElements.some((elem) => elem?.contains(event.target as Node))
      )
        return;

      memoizedHandler();
    };

    document.addEventListener("mousedown", handleOuterClick);
    return () => {
      document.removeEventListener("mousedown", handleOuterClick);
    };
  }, [memoizedHandler, options?.disabled, options?.ids, refs]);
}
